import React from 'react'
import { Title } from '../../Atoms'
// import { Button } from '@chakra-ui/react'
import { Bar } from '../../Organisms/Graphs'
import "./style.css";
import { Checkbox } from '@chakra-ui/react';

const StatCard = ({ card }) => {
  return (
    <div className="card stats-graph-card">
      <div className="header-container">
        <Title>{card.title}</Title>
        { card.showCheckbox ? (
          <Checkbox onChange={card.handleCheckbox} isChecked={card.checked} className='graph-checkbox' colorScheme='purple'>
            { card.checkboxLabel }
          </Checkbox>
        ) : null}
      </div>
      <div className="average-total-stats">
        <label>
          {card.averageStats.labelFirst.label}
          <p>{card.averageStats.labelFirst.value}</p>
        </label>
        <label>
          {card.averageStats.labelSecond.label}
          <p>{card.averageStats.labelSecond.value}</p>
        </label>
        <label>
          {card.averageStats.labelThird.label}
          <p>{card.averageStats.labelThird.value}</p>
        </label>
      </div>
      <article className="widget-main">
        <main className="widget-section">
          <div className="widget-chart drivers">
            <Bar fixLabelWidth={card.showCheckbox} parser={card.parser} data={card.stats} barThickness={20} axisStyles={card.axisStyles} tooltipFormatter={card.formatter} title={card.tooltipTitle || card.title} />
          </div>
        </main>
      </article>
    </div>
  )
}

export default StatCard
